import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { PlcTagDto } from "src/dtos/plcTag/plcTagDto";
import { getData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { EQM1011_R01Dto } from "./Dto_EQM1011_R01";
import { EQM1011_R01Filter } from "./Store_EQM1011_R01";

const baseUrl = `${config.apiUrl}/EQM1011_R01`;

/**
 * 검색조건을 Query Parameter로 변환한다. 값이 없는 조건은 보내지 않는다(undefined).
 * @param filter 화면 검색조건
 * @returns compCd, date(yyyy-MM-dd), tagId
 */
const getEQM1011_R01Params = (
    filter: Partial<EQM1011_R01Filter>,
) => ({
    compCd: filter.compCd || undefined,
    date: filter.baseDate ? formatDate(filter.baseDate) : undefined,
    tagId: filter.tagId || undefined,
});

export const getEQM1011_R01List = async (
    filter: Partial<EQM1011_R01Filter>,
) => {
    return getData<ResponseDto<EQM1011_R01Dto[]>>(baseUrl, {
        params: getEQM1011_R01Params(filter),
    });
};

/**
 * "데이터종류" 선택 목록 조회 (GET /EQM1011_R01/tag). 사업장 구분 없이 사용 중인 태그 전체를 받는다.
 * @returns 사용 중인 PLC 태그 목록
 */
export const getEQM1011_R01TagList = async () => {
    return getData<ResponseDto<PlcTagDto[]>>(`${baseUrl}/tag`);
};
